import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/CSS/login.css";
import API_BASE_URL from "../config";
import { AuthContext } from "../components/AuthContext";

function Login() {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleLogin = async (e) => {
    setIsSubmitting(true);
    e.preventDefault(); // Prevent page reload

    if (!user || !password) {
      alert("Please enter both username and password.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(API_BASE_URL + "/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user, password }),
      });

      const data = await response.json();

      if (data.success) {
        // const loggedInUser = {
        //   name: user,
        // };
        login(user);
        navigate("/dashboard");
      } else {
        alert(data.error || "Invalid login.");
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Server error : " + error.message);
      setIsSubmitting(false);
    }
  };

  function togglePassword() {
    setShowPassword(!showPassword);
  }

  return (
    <div className="login-page">
      <div className="container">
        <div className="message">
          <h2>Welcome</h2>
        </div>
        <div className="login-container">
          <h3>Login</h3>
          <hr />
          <form id="login-form">
            <div className="login-input-group">
              <input
                type="text"
                value={user}
                onChange={(e) => setUser(e.target.value)}
                required
                placeholder="Username"
              />
            </div>

            <div className="login-input-group">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Password"
              />
              <i
                className="fa-solid fa-eye toggle-password"
                id="togglePassword"
                onClick={togglePassword}
              ></i>
            </div>

            {/* <div className="login-input-group">
              <select
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Type
                </option
                <option value="Master">Master</option>
                <option value="Project Progress">Project Progress</option>
              </select>
            </div> */}
          </form>
          <div className="button">
            <button
              className="btn"
              onClick={handleLogin}
              disabled={isSubmitting}
            >
              Login
            </button>
            <button
              className="btn"
              onClick={() => navigate("/signup")}
              disabled={isSubmitting}
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
